/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Bank',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M2.313 6.369a.57.57 0 0 0-.313.51v2.015a.57.57 0 0 0 .571.571h1.93v9H2.571a.57.57 0 0 0-.571.571v2.858a.57.57 0 0 0 .571.571h18.858a.57.57 0 0 0 .571-.571v-2.858a.57.57 0 0 0-.571-.571H19.5v-9h1.929A.57.57 0 0 0 22 8.894V6.879a.57.57 0 0 0-.313-.51l-9.429-4.773a.57.57 0 0 0-.516 0L2.313 6.369zm18.487.896L12 2.81 3.2 7.265v1h17.6v-1zm-5.3 2.2h-1.498v9H15.5v-9zm-5.498 9H8.501v-9h1.501v9zm-6.801 1.2v1.6h17.6v-1.6H3.2zm2.501-10.2h1.6v8.997h-1.6V9.466zm7.101 0h-1.6v8.997h1.6V9.466zm3.898 0h1.6v8.997h-1.6V9.466z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
